"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    getNightlyRate: ()=>getNightlyRate,
    getSavingsPct: ()=>getSavingsPct,
    getStrikePrice: ()=>getStrikePrice,
    getTotalPrice: ()=>getTotalPrice
});
const getNightlyRate = ({ priceDisplayRegulation, nightlyAllRoomsPriceExcludingTax, nightlyRateIncludingTaxesAndFees, nightlyRateExcludingTaxesAndFees, price })=>{
    if ('TOTAL_PRICE_PROMINENT' === priceDisplayRegulation && nightlyRateIncludingTaxesAndFees) return nightlyRateIncludingTaxesAndFees;
    if ('TAX_EXCL_TOTAL_PRICE_PROMINENT' === priceDisplayRegulation && nightlyAllRoomsPriceExcludingTax) return nightlyAllRoomsPriceExcludingTax;
    return nightlyRateExcludingTaxesAndFees || price || '';
};
const getStrikePrice = ({ priceDisplayRegulation, grandTotalStrikeThroughPriceExcludingTax, grandTotalStrikeThroughPrice })=>{
    if ('TOTAL_PRICE_PROMINENT' === priceDisplayRegulation && grandTotalStrikeThroughPrice) return grandTotalStrikeThroughPrice;
    if ('TAX_EXCL_TOTAL_PRICE_PROMINENT' === priceDisplayRegulation && grandTotalStrikeThroughPriceExcludingTax) return grandTotalStrikeThroughPriceExcludingTax;
    return grandTotalStrikeThroughPriceExcludingTax || grandTotalStrikeThroughPrice || '';
};
const getTotalPrice = ({ priceDisplayRegulation, grandTotalExcludingTax, totalPrice })=>{
    if ('TOTAL_PRICE_PROMINENT' === priceDisplayRegulation && totalPrice) return totalPrice;
    if ('TAX_EXCL_TOTAL_PRICE_PROMINENT' === priceDisplayRegulation && grandTotalExcludingTax) return grandTotalExcludingTax;
    return totalPrice || grandTotalExcludingTax || '';
};
const getSavingsPct = ({ priceDisplayRegulation, grandTotalSavingsPctExcludingTax, savingsPct })=>{
    if ('TOTAL_PRICE_PROMINENT' === priceDisplayRegulation && savingsPct) return savingsPct;
    if ('TAX_EXCL_TOTAL_PRICE_PROMINENT' === priceDisplayRegulation && grandTotalSavingsPctExcludingTax) return grandTotalSavingsPctExcludingTax;
    return savingsPct || grandTotalSavingsPctExcludingTax || '';
};
exports.getNightlyRate = __webpack_exports__.getNightlyRate;
exports.getSavingsPct = __webpack_exports__.getSavingsPct;
exports.getStrikePrice = __webpack_exports__.getStrikePrice;
exports.getTotalPrice = __webpack_exports__.getTotalPrice;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "getNightlyRate",
    "getSavingsPct",
    "getStrikePrice",
    "getTotalPrice"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
